import { ItensToInspectInteractor, ItensToInspectRequest, ItensToInspectStructRequest } from "../../Coordinator/ItensToInspect/ItensToInspectInteractor";

export class ItensToInspectViewModel {
	private interactor: ItensToInspectInteractor;

	constructor() {
		this.interactor = new ItensToInspectInteractor();
	}

	public fetchSave(obj: any): PromiseLike<any> {
		var request = new ItensToInspectRequest(
			obj["sgepitensinspecaodengue"] ? parseInt(obj["sgepitensinspecaodengue"]) : 0,
			obj["codigo"] ? obj["codigo"] : "",
			obj["nome"] ? obj["nome"] : ""
		)
		return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(true)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchDataOne(obj: any): PromiseLike<any> {
		var request = new ItensToInspectStructRequest(obj["sgepitensinspecaodengue"] ? parseInt(obj["sgepitensinspecaodengue"]) : 0)
		return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
}